import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
interface AnalysisScreenProps {
  onComplete: () => void;
}
export function AnalysisScreen({
  onComplete
}: AnalysisScreenProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 3000); // 3 seconds analysis
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="flex flex-col items-center justify-center text-center px-6 py-8 min-h-[100dvh] bg-white max-w-md mx-auto shadow-xl" data-id="element-12">
      <motion.div animate={{
      scale: [1, 1.2, 1],
      rotate: [0, 180, 360]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="w-24 h-24 bg-green-50 rounded-full flex items-center justify-center mb-8 text-primary" data-id="element-13">
        <Activity className="w-12 h-12" data-id="element-14" />
      </motion.div>

      <h2 className="text-3xl font-bold text-dark mb-4" data-id="element-15">
        Analizando tu metabolismo...
      </h2>

      <div className="w-full max-w-xs mb-6" data-id="element-16">
        <div className="h-3 w-full bg-gray-100 rounded-full overflow-hidden" data-id="element-17">
          <div className="h-full bg-primary rounded-full animate-progress" data-id="element-18" />
        </div>
      </div>

      <p className="text-gray-500 font-medium" data-id="element-19">
        Comparando tus respuestas con nuestro sistema metabólico.
      </p>
    </motion.div>;
}